import React, { FC } from "react";
import UserIconSVG from "../../svg/UserIconSVG";
import { useTranslation } from "react-i18next";

interface BlockedUsersListButtonProps {
    onClick: () => void;
}
const BlockedUsersListButton: FC<BlockedUsersListButtonProps> = ({ onClick }) => {
    const { t } = useTranslation();

    return (
        <div className="flex items-center justify-end tmax4:mr-5 cursor-pointer group" onClick={onClick}>
            <UserIconSVG className="w-[32px] dmax2:w-[24px] mr-2 dmax2:mr-1 text-textFaded group-hover:text-textWhite transition duration-300" />
            <span className="H14 w-fit whitespace-nowrap dmax2:H14B text-textFaded group-hover:text-textWhite transition duration-300">
                {t("common.blockedList")}
            </span>
        </div>
    );
};

export default BlockedUsersListButton;
